"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BrandContextProvider = exports.BrandContext = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactHelmet = require("react-helmet");
var _activeBrandCssMap = require("../autoGenerated/activeBrandCssMap");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable react/forbid-prop-types */

const BrandContext = exports.BrandContext = /*#__PURE__*/(0, _react.createContext)(null);
const BrandContextProvider = _ref => {
  let {
    children,
    brandConfig
  } = _ref;
  const [activeBrandContext, setActiveBrandContext] = (0, _react.useState)(brandConfig);
  const isLocalEnv = process.env.REACT_APP_ENV && process.env.REACT_APP_ENV === 'local';
  const applyBrandContext = (0, _react.useCallback)(newBrandContext => {
    setActiveBrandContext(newBrandContext);
  }, [setActiveBrandContext]);
  const brandProviderValue = (0, _react.useMemo)(() => ({
    activeBrandContext,
    applyBrandContext
  }), [activeBrandContext, applyBrandContext]);
  const getBrandKey = () => {
    var _activeBrandContext$t;
    const broker = activeBrandContext === null || activeBrandContext === void 0 || (_activeBrandContext$t = activeBrandContext.theme) === null || _activeBrandContext$t === void 0 || (_activeBrandContext$t = _activeBrandContext$t.brand) === null || _activeBrandContext$t === void 0 ? void 0 : _activeBrandContext$t.broker;
    return broker ? broker.toLowerCase() : 'classic';
  };
  const getLocalCssUrl = brandKey => {
    return "styles/brands/petsure-ui-library-".concat(brandKey, "/").concat(brandKey, ".css");
  };
  return /*#__PURE__*/_react.default.createElement(BrandContext.Provider, {
    value: brandProviderValue
  }, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("link", {
    id: "themeCssFile_".concat(getBrandKey()),
    rel: "stylesheet",
    type: "text/css",
    href: "".concat(isLocalEnv ? getLocalCssUrl(getBrandKey()) : _activeBrandCssMap.ActiveBrandMap[getBrandKey()], "?").concat(Date.now())
  }), activeBrandContext && activeBrandContext.theme.brand.cssUrls && activeBrandContext.theme.brand.cssUrls.map((cssUrl, index) => /*#__PURE__*/_react.default.createElement("link", {
    key: "css_".concat(activeBrandContext.theme.brand.key, "_").concat(index + 1),
    rel: "stylesheet",
    type: "text/css",
    href: cssUrl
  }))), children);
};
exports.BrandContextProvider = BrandContextProvider;
BrandContextProvider.propTypes = {
  children: _propTypes.default.any,
  brandConfig: _propTypes.default.any
};
var _default = exports.default = {
  BrandContext,
  BrandContextProvider
};